var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"m-row",style:({
    justifyContent: _vm.jc,
    alignItems: _vm.ai,
    alignContent: _vm.ac,
    flexDirection: _vm.direction,
    flexWrap: _vm.wrap ? 'wrap' : 'no-wrap',
  })},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }